import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, HostBinding, Input, Output, computed, signal } from '@angular/core';
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import { QuestionType } from '@empathy/survey/base';

import { NotepadQuestionTypeConfig } from '../../models/notepad-question-type-config.constant';
import { ExtendedQuestionType } from '../../models/notepad-question-type.constant';

@Component({
  selector: 'empathy-question-type-select',
  templateUrl: './question-type-select.component.html',
  styleUrl: './question-type-select.component.scss',
  animations: [
    trigger('animations', [
      transition(':enter', [
        style({
          opacity: 0,
          scale: 0.8
        }),
        animate(
          '0.15s ease-in-out',
          style({
            opacity: 1,
            scale: 1
          })
        )
      ]),
      transition(':leave', [
        style({
          opacity: 1,
          scale: 1
        }),
        animate(
          '0.15s ease-in-out',
          style({
            opacity: 0.8,
            scale: 0.8
          })
        )
      ])
    ])
  ]
})
export class QuestionTypeSelectComponent {
  @Input() isOpen = false;
  @Input() selected: QuestionType;

  @Output() completed = new EventEmitter<ExtendedQuestionType>();

  @HostBinding('@animations') animationState = true;

  faMagnifyingGlass = faMagnifyingGlass;
  faXmark = faXmark;

  searchQuery = signal<string>('');
  items = computed(() => {
    const sq = this.searchQuery();
    return this.questionTypeConfig.filter((x) => x.text.toLocaleLowerCase().includes(sq.toLocaleLowerCase()));
  });

  questionTypeConfig = Object.values(NotepadQuestionTypeConfig);

  selectType(type: ExtendedQuestionType): void {
    this.completed.emit(type);
  }

  onSearchUpdated(sq: string): void {
    this.searchQuery.set(sq);
  }
}
